export default __webpack_public_path__ + "static/media/ic_360degree_view.a4ccaccb.svg";